<div class="flex flex-col bg-white comic-book">
  <div
    class="rotate flex flex-wrap min-h-screen background-pink relative border-4 border-black"
  >
    <span class="absolute w-1/4 right-0 h-full halftone top-right"></span>
    <span
      class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
    ></span>

    <div class="straighten w-full md:w-1/2 p-4 flex items-center">
      <div class="p-8 md:.panel-container">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
            >Contact Us</span
          >
        </h2>
        <h3
          class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-gray-900"
        >
          Get in Touch
        </h3>
        <p class="mt-6 text-2xl md:3xl text-pink-50">
          We'd love to hear from you! Whether you have a question about our
          resources, want to contribute, or just want to say hello, don't
          hesitate to reach out.
        </p>
        <p class="mt-6 text-2xl md:3xl text-pink-50">
          Email us at:
          <a
            href="mailto:wave@studyheroes.app"
            class="text-blue-300 hover:underline"
            >{{ 'wave@studyheroes.app' }}</a
          >
        </p>

        <p class="mt-6 text-2xl md:3xl text-pink-50 inline-flex items-center">
          or message us on
          <a
            href="https://x.com/studyheroesapp"
            target="_blank"
            class="text-pink-50 hover:text-pink-200 ml-2 inline-flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 1668.56 1221.19"
              fill="currentColor"
              class="ml-1"
            >
              <path
                d="m283.94 167.31 386.39 516.64-388.83 420.05h87.51l340.42-367.76 275.05 367.76h297.8l-408.13-545.7 361.92-390.99h-87.51l-313.51 338.7-253.31-338.7zm128.69 64.46h136.81l604.13 807.76h-136.81z"
                transform="translate(52.390088 -25.058597)"
              />
            </svg>
          </a>
        </p>
      </div>
    </div>
    <div class="w-full md:w-1/2 p-4 flex items-center">
      <div class="p-4 straighten">
        <h2 class="text-container mb-6">
          <span
            class="text text-flat font-bangers text-4xl md:text-6xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
            >Join Our Mission</span
          >
        </h2>
        <p class="text-2xl text-pink-50 mb-6">
          Study Heroes is on a mission to make quality education accessible to
          everyone. If you're passionate about education and want to make a
          difference, we'd love to have you on board!
        </p>
        <a
          href="/get-involved"
          class="btn btn-lg border-2 bg-purple-700 px-3.5 py-2.5 text-xl font-semibold text-white shadow-sm shadow-slate-950 hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600"
          >Get Involved</a
        >
      </div>
    </div>
    <div class="w-full md:w-1/2 p-4 flex items-center">
      <div class="p-4 straighten">
        <h2 class="text-container mb-6">
          <span
            class="text text-flat font-bangers text-4xl md:text-6xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
            >Follow Us</span
          >
        </h2>
        <p class="text-2xl text-pink-50 mb-6">
          Stay updated with our latest resources and initiatives:
        </p>
        <div class="flex space-x-6">
          <a
            href="https://x.com/studyheroesapp"
            target="_blank"
            class="text-pink-50 hover:text-pink-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 1668.56 1221.19"
              fill="currentColor"
            >
              <path
                d="m283.94 167.31 386.39 516.64-388.83 420.05h87.51l340.42-367.76 275.05 367.76h297.8l-408.13-545.7 361.92-390.99h-87.51l-313.51 338.7-253.31-338.7zm128.69 64.46h136.81l604.13 807.76h-136.81z"
                transform="translate(52.390088 -25.058597)"
              />
            </svg>
          </a>
          <a
            href="https://www.youtube.com/@StudyHeroes"
            target="_blank"
            class="text-pink-50 hover:text-pink-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
